import { Provider } from "@angular/core";
import { FormDeliveryService, ReportDeliveryService } from "./services";

export function provideReporting(): Array<Provider>
{
    return [
        FormDeliveryService,
        ReportDeliveryService,
    ];
}

